import {
  getDoctorByIdFailure,
  getDoctorByIdLoading,
  getDoctorByIdSuccess,
  getDoctorFailure,
  getDoctorLoading,
  getDoctorSuccess,
  updateDoctorFailure,
  updateDoctorLoading,
  updateDoctorSuccess,
} from "@redux/slices/doctorSlice";
import { getDoctor } from "@services/doctor/getDoctor";
import { getDoctorById } from "@services/doctor/getDoctorById";
import { updateDoctor } from "@services/doctor/updateDoctor";
import { useDispatch } from "react-redux";
import getErrorStatement from "src/utils/getErrorStatement";
import { notify } from "src/utils/notify";

const useDoctor = () => {
  const dispatch = useDispatch();

  const handleGetDoctor = async (searchFilters) => {
    try {
      dispatch(getDoctorLoading());
      const response = await getDoctor(searchFilters);
      dispatch(getDoctorSuccess(response.data));
    } catch (error) {
      dispatch(getDoctorFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleUpdateDoctor = async (doctorId, updatedData) => {
    try {
      dispatch(updateDoctorLoading());
      const response = await updateDoctor(doctorId, updatedData);
      dispatch(updateDoctorSuccess(response.data));
      notify("Doctor details updated successfully", "success");
      handleGetDoctorById(updatedData?.local?.email);
    } catch (error) {
      dispatch(updateDoctorFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleGetDoctorById = async (doctorId) => {
    try {
      dispatch(getDoctorByIdLoading());
      const response = await getDoctorById(doctorId);
      dispatch(getDoctorByIdSuccess(response.data));
    } catch (error) {
      dispatch(getDoctorByIdFailure());
      notify(getErrorStatement(error));
    }
  };

  return {
    handleGetDoctor,
    handleUpdateDoctor,
    handleGetDoctorById,
  };
};

export default useDoctor;
